<template>
  <div
    class="
      app-numeric
      v-input v-input--hide-details v-input--is-label-active
      theme--light
      v-text-field
      v-text-field--is-booted
      v-text-field--enclosed
      v-text-field--outlined
    "
  >
    <div class="v-input__control">
      <div class="v-input__slot">
        <fieldset aria-hidden="true">
          <legend style="width: 62.25px">
            <span class="notranslate"></span>
          </legend>
        </fieldset>
        <div class="v-text-field__slot">
          <label
            :id="id"
            class="v-label v-label--active theme--light"
            style="left: 0px; right: auto; position: absolute"
            >{{ label }}</label
          >
          <vue-numeric
            :id="id"
            :name="id"
            v-model="val"
            :disabled="enable"
            :currency="prefix"
            separator="."
            :empty-value="0"
            :precision="casadecimal"
            @input="onInput()"
            @change="onChange()"
            @blur="onBlur()"
          ></vue-numeric>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id", "label", "enable", "prefix", "nrodecimal", "value"],
  data: () => ({
    val: 0,
    casadecimal: 2,
  }),
  mounted() {
    if (this.value != null && this.value != "") this.val = this.value;

    if (typeof this.nrodecimal != "undefined")
      this.casadecimal = this.nrodecimal;
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  methods: {
    onInput() {
      this.emitEvento("onInput");
    },
    onChange() {
      this.emitEvento("onChange");
    },
    onBlur() {
      this.emitEvento("onBlur");
    },
    emitEvento(evento) {
      this.$emit(evento, {
        id: this.id,
        value: this.val,
      });
    },
  },
};
</script>
